const PLATFORM_QQ = 'qq';
const PLATFORM_WX = 'wx';
const PLATFORM_PC = 'pc';
const PLATFORM_GAME = 'game';
const PLATFORM_OTHERS = 'others';

const DEVICE_IOS = 'ios';
const DEVICE_ANDROID = 'android';
const DEVICE_OTHERS = 'others';
const OS_OTHERS = 'others';

let UA = 'none browser';
if (typeof window !== 'undefined') {
  UA = window.navigator.userAgent;
}

const isIphone = UA.indexOf('iPhone') >= 0;

const isIpad = /(iPad).*OS\s([\d_]+)/.test(UA);

const isIos = isIphone || isIpad;

const isAndroid = UA.indexOf('Android') >= 0;

const isSafari = /^((?!chrome|android).)*safari/i.test(UA);

const isMac = UA.indexOf('Macintosh') >= 0;

const isWin = UA.indexOf('Windows') >= 0;

const isQQ = /QQ\/([\d.]+)/.test(UA);

const isWX = UA.indexOf('MicroMessenger') >= 0;

const isGame = (new RegExp('itopencodeparam').test(location.search) || /msdkEncodeParam/.test(location.search) || new RegExp('C_MSDK_FLAG').test(location.search)) && UA.indexOf('GameHelper') === -1; // 标准msdk 同时兼容下和平营地跟游戏一样的参数

const isMobile = /AppleWebKit.*Mobile.*/i.test(UA);

const isMiniprogram = /miniProgram/i.test(UA) || false; // 判断是否在微信小程序

const isCeibaMP = new URL(window.location.href).searchParams.get('isCeibaMP') || false; // 判断是否在ceiba小程序环境

const platform = {
  isIos,
  isIphone,
  isIpad,
  isAndroid,
  isSafari,
  isMac,
  isWin,
  isQQ,
  isWX,
  isGame,
  isMobile,
  isMiniprogram,
  isCeibaMP,
  os: OS_OTHERS,
  device: DEVICE_OTHERS,
  platform: PLATFORM_OTHERS,
  osVersion: '',
};

// 平台
if (platform.isWX) {
  platform.platform = PLATFORM_WX;
} else if (platform.isQQ) {
  platform.platform = PLATFORM_QQ;
} else if (isGame) {
  platform.platform = PLATFORM_GAME;
} else if (!platform.isMobile) {
  platform.platform = PLATFORM_PC;
} else {
  platform.platform = PLATFORM_OTHERS;
}

// 设备
if (platform.isIos) {
  platform.device = DEVICE_IOS;
} else if (platform.isAndroid) {
  platform.device = DEVICE_ANDROID;
} else {
  platform.device = DEVICE_OTHERS;
}

// 操作系统
if (platform.isIos) {
  platform.os = 'ios';
} else if (platform.isAndroid) {
  platform.os = 'android';
} else if (isWin) {
  platform.os = 'windows';
} else if (isMac) {
  platform.os = 'mac';
}

// 获取系统版本号
const REG_VERSION = {
  ios: /OS (.*?) like Mac OS/,
  android: /Android (.*?);/i,
  windows: /Windows NT (.*?);/i,
  mac: /\(Macintosh; Intel Mac OS X (.*?)\)/,
};
const osVersion = (UA.match(REG_VERSION[platform.os] || '') || ['', ''])[1];
platform.osVersion = osVersion ? osVersion.replace(/_/g, '.') : '';

export default platform;

